import { createContext } from 'react';

const Context = createContext({
    user: null,
    searchKey: '',
});

export default Context;
